import { graphql } from "@/data-access/graphql";

export const Login = graphql(`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      tokens {
        accessToken
        refreshToken
      }
      user {
        id
      }
    }
  }
`);

export const Logout = graphql(`
  mutation logout {
    logout
  }
`);

export const StartSso = graphql(`
  mutation startSso($email: String) {
    startSso(email: $email) {
      startUrl
    }
  }
`);

export const ExchangeSso = graphql(`
  mutation exchangeSsoCode($code: String!) {
    exchangeSsoCode(code: $code) {
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`);
